import { submitFormData, submitJsonData, submitMultipartFormData } from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
 * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
 * @param query: {curPage,pageSize}
 * @returns Promise
 */
export function findApplicationPage(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/application/page',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
 * @param query: {curPage,pageSize}
 * @returns Promise
 */
export function findApplicationPageList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/application/pageList',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
 * @param query: {}
 * @returns Promise
 */
export function findApplicationList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/application/list',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id}
 * @param query: {}
 * @returns Promise
 */
export function getApplication(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/application/info',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {sysCode, name, icon, classify, accessCode, accessKey, appAccessUrl, appAccessHeadParam, appAccessBodyParam, verifyUrl, verifyHeadParam, verifyBodyParam, verifyResponseParam, gtasksUrl, gtasksHeadParam, gtasksBodyParam, remark, roleIds, roleIdList, roleNames, createTime, sort, showApp, showPage, pageUrl, status, appPage, isShowApp, orgIds, orgNames, orgIdList, isShowPC, verifyAccountAndPwd, pcRoleIds, pcOrgIds, pcRoleIdList, pcOrgIdList}
 * @param query: {}
 * @returns Promise
 */
export function addApplication(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/application/add',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, sysCode, name, icon, classify, accessCode, accessKey, appAccessUrl, appAccessHeadParam, appAccessBodyParam, verifyUrl, verifyHeadParam, verifyBodyParam, verifyResponseParam, gtasksUrl, gtasksHeadParam, gtasksBodyParam, remark, roleIds, roleIdList, roleNames, createTime, sort, showApp, showPage, pageUrl, status, appPage, isShowApp, orgIds, orgNames, orgIdList, isShowPC, verifyAccountAndPwd, pcRoleIds, pcOrgIds, pcRoleIdList, pcOrgIdList}
 * @param query: {}
 * @returns Promise
 */
export function editApplication(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/application/edit',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id}
 * @param query: {}
 * @returns Promise
 */
export function deleteApplication(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/application/delete',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
 * @param query: {}
 * @returns Promise
 */
export function findApplicationOfUserList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/application/findAppOfUser',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}


/**
 * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
 * @param query: {}
 * @returns Promise
 */
export function applicationList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/role/application/list',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
 * @param query: {}
 * @returns Promise
 */
export function addApplicationList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/role/application/add',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {sysCode, key, name, icon, userId, classify, isShowApp, isShowPC}
 * @param query: {}
 * @returns Promise
 */
export function delApplicationList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/role/application/del',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}
